<template>
  <div>
    <v-row id="router" class="ma-0 pa-0" style="align-items: flex-start; align-content: flex-start" :style="viewStyle">
      <div id="listTable">
        <v-simple-table fixed-header>
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-center">下載證書</th>
                <th @click="sort('examNo')">場次代碼<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('examDate')">認證日期<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class1')">認證項目<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class2')">認證模組<v-icon small>icon-form_sort_off</v-icon></th>
                <th @click="sort('class3')">認證廠商<v-icon small>icon-form_sort_off</v-icon></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data,index) in datasets" :key="index">
                <td class="text-center" style="min-width: 100px">
                  <v-btn v-if="data.examNo" outlined style="background:#215DA7; color:#FFF" @click="getCertificatePdf(index)">下載證書</v-btn>
                  <v-btn v-if="!data.examNo" outlined style="background:#215DA7; color:#FFF" @click="getCertificateThirdPdf(index)">下載證書</v-btn>
                </td>
                <td style="min-width: 120px">
                  <h4 v-if="data.examNo">{{data.examNo}}</h4>
                  <v-row v-if="!data.examNo" class="ma-0 pa-0">
                    <v-icon class="pr-1 mt-n1" color="#F00" size="26">mdi-medal</v-icon>
                    <h4>第三張證書</h4>
                  </v-row>
                </td>
                <td style="min-width: 110px"><h4>{{data.examDate}}</h4><h4>{{data.examTime}}</h4></td>
                <td style="min-width: 130px"><h4 class="multilineEllipsis">{{data.class1}}</h4></td>
                <td style="min-width: 110px"><h4 class="multilineEllipsis">{{data.class2}}</h4></td>
                <td style="min-width: 130px"><h4 class="multilineEllipsis">{{data.class3}}</h4></td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </div>
    
      <v-row class="ma-0 px-5 py-3" style="justify-content: center; align-items: center;">
        <h4 class="start">*如發現證書內容不完整或有其他異常情況，請來信(service@cerps.org.tw)洽詢。</h4>
      </v-row>
      <!-- <v-row class="px-5 py-0"> -->
        <!-- <v-col class="col-0 col-sm-0 col-md-2 col-lg-7 pagination-max pl-5 mt-3 text-right pr-8">共 {{pagination.totalCount}} 筆</v-col>
        <v-col class="col-12 col-sm-8 col-md-6 col-lg-3 pr-0">
          <v-pagination color="#81C0E2" v-model="pagination.page" :length="pagination.totalPage"
          :total-visible="5"></v-pagination>
        </v-col>
        <v-col class="col-12 col-sm-4 col-md-4 col-lg-2">
          <v-row class="row">
            <v-col class="col-5 col-sm-4 pt-3 text-right">前往</v-col>
            <v-col class="col-2 col-sm-4 pa-0">
            <v-text-field outlined dense v-model="destPage" @keyup.enter="setDestPage()"></v-text-field>
            </v-col>
            <v-col class="col-5 col-sm-4 pt-3 text-left">頁</v-col>
          </v-row>
        </v-col> -->
      <!-- </v-row> -->
    </v-row>
  </div>
</template>

<script>


export default {
  name: 'MyCertificateList',
  components: {},
  mounted(){
    this.getDataset()
  },
  data:() => ({
    datasets: [],
    pagination:{page:1,totalPage:10,totalCount:10},
    orderBy:'examDate',
    direction:'desc',
    destPage:'',
    viewStyle:{},
  }),
  created(){
    this.calculateWindows()
    this.$root.$on('windowInnerHeight',()=>{
      this.calculateWindows()
    })
  },
  watch:{
    "pagination.page":function(){
      this.getDataset()
    }
  },
  methods:{
    calculateWindows(){
    this.viewStyle = {height: window.innerHeight-64 + 'px'}
    },
    redirectPath(path, id){
      this.$router.push({path: path, query: {
        id: this.$Global.encrypt(JSON.stringify(id)),
      }})
    },
    setDestPage(){
      this.pagination.page = parseInt(this.destPage)
    },
    sort(field){
      this.orderBy = field
      this.direction = (this.direction == 'desc') ? 'asc' : 'desc'
      this.getDataset()
    },
    search(){
      (this.pagination.page == 1) ? this.getDataset() : this.pagination.page = 1
    },
    getDataset(){
      var self = this
      var request = {
        method: 'GET',
        url: '/myCertificate',
        params: {
          'idCard':sessionStorage.getItem('cerpsMemberIdCard'),
          'page':self.pagination.page,
          'limit':10,
          'order': self.orderBy,
          'direction': self.direction,
          'source': '',
        },
      }
      this.$http(request).then(function(response) {
        self.datasets = response.data.data
        // self.pagination.totalCount = response.data.data.total
        // self.pagination.totalPage = response.data.data.page
      }).catch(()=>{
        console.log('系統錯誤: '+'請聯繫系統管理人員，編號為Ril-7956')
      })
    },
    getCertificatePdf(index){
      var self = this
      var request = {
        method: 'GET',
        url: '/certificateDownload/exportpdf',
        params: {
          'id': this.datasets[index].id,
          'examNo': this.datasets[index].examNo,
          'idCard': this.datasets[index].idCard,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = (self.datasets[index].examNo + '_證書.pdf')
        link.click()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7965')
      }).finally(function() {
      });
    },
    
    getCertificateThirdPdf(index){
      var self = this
      var request = {
        method: 'GET',
        url: '/certificateThirdDownload/exportpdf',
        params: {
          'id': this.datasets[index].id,
          'idCard': this.datasets[index].idCard,
          'printType': 'member',
        },
        responseType: 'arraybuffer'
      }
      this.$http(request).then(function(response) {
        var blob = new Blob([response.data], { type: 'application/pdf' });
        // IE專用方法
        //window.navigator.msSaveBlob(blob, 'erpComeMoPage.pdf'); 
        let link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        link.download = ('證書.pdf')
        link.click()
      }).catch(()=>{
        self.$refs.ShowMsg.open(0,'系統錯誤','請聯繫系統管理人員，編號為Rif-7965')
      }).finally(function() {
      });
    },
  }
}
</script>

<style>
  @media (max-width: 959px) {
    .pagination-max {
      display: none !important;
    }
  }
</style>